import { jsxs as c, jsx as l, Fragment as k } from "react/jsx-runtime";
import * as h from "react";
import Y, { useState as I, useEffect as E, forwardRef as x } from "react";
import { Table as u, Heading as O, BodyShort as w, BodyLong as B, Tabs as y } from "@navikt/ds-react";
import S from "dayjs";
let T = 0;
function $(e) {
  const [s, t] = I(e), n = e || s;
  return E(() => {
    s == null && (T += 1, t(`aksel-icon-${T}`));
  }, [s]), n;
}
const L = Y.useId;
function N(e) {
  var s;
  return L !== void 0 ? L().replace(/(:)/g, "") : (s = $(e)) !== null && s !== void 0 ? s : "";
}
var C = function(e, s) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && s.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      s.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
};
const R = x((e, s) => {
  var { title: t, titleId: n } = e, a = C(e, ["title", "titleId"]);
  let o = N();
  return o = t ? n || "title-" + o : void 0, h.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: s, "aria-labelledby": o }, a),
    t ? h.createElement("title", { id: o }, t) : null,
    h.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M12.75 6a.75.75 0 0 0-1.5 0v6c0 .199.079.39.22.53l2.5 2.5a.75.75 0 1 0 1.06-1.06l-2.28-2.28z", clipRule: "evenodd" })
  );
});
var P = function(e, s) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && s.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      s.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
};
const F = x((e, s) => {
  var { title: t, titleId: n } = e, a = P(e, ["title", "titleId"]);
  let o = N();
  return o = t ? n || "title-" + o : void 0, h.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: s, "aria-labelledby": o }, a),
    t ? h.createElement("title", { id: o }, t) : null,
    h.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7 7c.141.14.22.331.22.53v11a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75v-4.25h-2.5V21a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75V10a.75.75 0 0 1 .22-.53z", clipRule: "evenodd" })
  );
}), A = {
  office: {
    chooseBetweenOffices: "You can choose one of the following offices.",
    closed: "Closed",
    openingHoursWithoutAppointment: "Opening hours without an appointment",
    openingHours: "Opening hours",
    appointmentOnly: "Kun timeavtale",
    specialOpeningHours: "Special opening hours",
    address: "Visiting address"
  },
  dateTime: {
    weekDayNames: {
      mon: "Monday",
      tue: "Tuesday",
      wed: "Wednesday",
      thu: "Thursday",
      fri: "Friday",
      sat: "Saturday",
      sun: "Sunday"
    },
    time: "time",
    day: "day"
  }
}, z = {
  office: {
    chooseBetweenOffices: "Du kan velje eit av disse kontora.",
    closed: "Stengt",
    openingHoursWithoutAppointment: "Opningstider når du ikkje har avtale",
    openingHours: "Opningstider",
    appointmentOnly: "Kun timeavtale",
    specialOpeningHours: "Spesielle åpningstider",
    address: "Besøksadresse"
  },
  dateTime: {
    weekDayNames: {
      mon: "Måndag",
      tue: "Tysdag",
      wed: "Onsdag",
      thu: "Torsdag",
      fri: "Fredag",
      sat: "Laurdag",
      sun: "Søndag"
    },
    time: "tid",
    day: "dag"
  }
}, D = {
  office: {
    chooseBetweenOffices: "Du kan velge ett av de følgende kontorene.",
    closed: "Stengt",
    openingHoursWithoutAppointment: "Åpningstider når du ikke har avtale",
    openingHours: "Åpningstider",
    appointmentOnly: "Kun timeavtale",
    specialOpeningHours: "Spesielle åpningstider",
    address: "Besøksadresse"
  },
  dateTime: {
    weekDayNames: {
      mon: "Mandag",
      tue: "Tirsdag",
      wed: "Onsdag",
      thu: "Torsdag",
      fri: "Fredag",
      sat: "Lørdag",
      sun: "Søndag"
    },
    time: "tid",
    day: "dag"
  }
}, W = {
  en: A,
  nn: z,
  no: D
}, b = (e, s) => {
  const t = W[s], n = {
    ...D[e],
    ...t && t[e]
  };
  return (a) => n[a];
};
var K = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, U = { exports: {} };
(function(e, s) {
  (function(t, n) {
    e.exports = n(S);
  })(K, function(t) {
    function n(i) {
      return i && typeof i == "object" && "default" in i ? i : { default: i };
    }
    var a = n(t), o = { name: "nb", weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"), weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"), weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"), months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"), monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"), ordinal: function(i) {
      return i + ".";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY [kl.] HH:mm", LLLL: "dddd D. MMMM YYYY [kl.] HH:mm" }, relativeTime: { future: "om %s", past: "%s siden", s: "noen sekunder", m: "ett minutt", mm: "%d minutter", h: "en time", hh: "%d timer", d: "en dag", dd: "%d dager", M: "en måned", MM: "%d måneder", y: "ett år", yy: "%d år" } };
    return a.default.locale(o, null, !0), o;
  });
})(U);
const V = (e) => {
  if (!e)
    return "";
  let s;
  const t = e.husnummer ? ` ${e.husnummer}` : "", n = e.husbokstav ? `${e.husbokstav}` : "";
  s = `${e.gatenavn}${t}${n}`;
  let a = e && e.poststed || "";
  return a = a.toUpperCase(), s += `, ${e.postnummer} ${a}`, s;
}, G = ({ datetime: e, language: s = "nb", short: t = !1, year: n = !1 }) => {
  const a = s === "en" ? "en-gb" : "nb";
  let o;
  return t && n ? o = "D. MMMM YYYY" : t ? o = "D. MMMM" : o = "L", e && S(e).locale(a).format(o);
}, q = {
  Mandag: "mon",
  Tirsdag: "tue",
  Onsdag: "wed",
  Torsdag: "thu",
  Fredag: "fri"
}, J = (e, s) => {
  const t = b("dateTime", s)("weekDayNames"), { dato: n, dag: a } = e;
  return n ? G({
    datetime: n,
    language: s,
    short: !0,
    year: !0
  }) : a ? t[q[a]] : "";
}, Q = "_srOnly_1ti4y_1", X = {
  srOnly: Q
}, H = ({ openingHours: e, language: s }) => {
  const t = b("office", s), n = b("dateTime", s), a = t("closed"), o = t("appointmentOnly"), i = n("day"), m = n("time"), g = (r) => r ? r.replace(":", ".") : "", _ = (r) => r.kunTimeavtale === "true" ? o : r.fra && r.til ? `${g(r.fra)}–${g(r.til)}` : a;
  return /* @__PURE__ */ c(u, { children: [
    /* @__PURE__ */ l(u.Header, { className: X.srOnly, children: /* @__PURE__ */ c(u.Row, { children: [
      /* @__PURE__ */ l(u.HeaderCell, { scope: "col", children: i }),
      /* @__PURE__ */ l(u.HeaderCell, { scope: "col", children: m })
    ] }) }),
    /* @__PURE__ */ l(u.Body, { children: e.map((r, f) => {
      const p = J(r, s);
      return /* @__PURE__ */ c(u.Row, { shadeOnHover: !1, children: [
        /* @__PURE__ */ l(u.HeaderCell, { className: "dayInformation", children: p }),
        /* @__PURE__ */ l(u.DataCell, { className: "openingInformation", children: _(r) })
      ] }, f);
    }) })
  ] });
}, M = ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag"], Z = (e) => {
  var n, a;
  const s = (n = e.aapningstider) == null ? void 0 : n.reduce(
    (o, i) => (i.dato ? o.exceptions.push(i) : o.regular.push(i), o),
    {
      regular: [],
      exceptions: []
    }
  ), t = (s == null ? void 0 : s.regular) || [];
  return t == null || t.sort((o, i) => M.indexOf(o.dag) - M.indexOf(i.dag)), {
    address: V(e.besoeksadresse),
    addressExtra: (a = e.besoeksadresse) == null ? void 0 : a.adresseTilleggsnavn,
    openingHoursExceptions: (s == null ? void 0 : s.exceptions) || [],
    openingHours: t,
    adkomstbeskrivelse: e.adkomstbeskrivelse
  };
}, ee = (e) => {
  const s = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
  return e.filter((t) => !!(t.dato && t.dato >= s)).sort((t, n) => {
    const a = new Date(t.dato).getTime(), o = new Date(n.dato).getTime();
    return a - o;
  });
}, ne = "_singleReception_rdj2p_1", te = "_heading_rdj2p_48", se = "_headingIcon_rdj2p_53", ae = "_iconPlace_rdj2p_58", oe = "_iconClock_rdj2p_63", re = "_iconInfo_rdj2p_68", ie = "_address_rdj2p_75", le = "_addressLine_rdj2p_82", de = "_addressExtra_rdj2p_82", d = {
  singleReception: ne,
  heading: te,
  headingIcon: se,
  iconPlace: ae,
  iconClock: oe,
  iconInfo: re,
  address: ie,
  addressLine: le,
  addressExtra: de
}, j = (e) => {
  const { language: s } = e, t = b("office", s), { address: n, adkomstbeskrivelse: a, openingHours: o, openingHoursExceptions: i, addressExtra: m } = Z(e), g = ee(i), _ = e.officeType === "HMS" ? t("openingHours") : t("openingHoursWithoutAppointment");
  return /* @__PURE__ */ c("div", { className: d.singleReception, children: [
    /* @__PURE__ */ c(O, { level: "3", size: "medium", spacing: !0, className: d.heading, children: [
      /* @__PURE__ */ l(F, { "aria-hidden": "true", className: `${d.headingIcon} ${d.iconPlace}` }),
      t("address")
    ] }),
    /* @__PURE__ */ c("section", { className: d.address, children: [
      m && /* @__PURE__ */ l(w, { className: d.addressExtra, children: m }),
      /* @__PURE__ */ l(w, { className: d.addressLine, children: n }),
      a && /* @__PURE__ */ l(w, { className: d.addressLine, size: "small", children: a })
    ] }),
    o.length > 0 && /* @__PURE__ */ c(k, { children: [
      /* @__PURE__ */ c(O, { level: "3", size: "medium", spacing: !0, className: d.heading, children: [
        /* @__PURE__ */ l(R, { "aria-hidden": "true", className: `${d.headingIcon} ${d.iconClock}` }),
        _
      ] }),
      /* @__PURE__ */ l(H, { openingHours: o, language: s })
    ] }),
    g.length > 0 && /* @__PURE__ */ c(k, { children: [
      /* @__PURE__ */ l(O, { level: "3", size: "medium", spacing: !0, children: t("specialOpeningHours") }),
      /* @__PURE__ */ l(H, { openingHours: g, language: s })
    ] })
  ] });
}, ce = "_officeTabs_1uiec_1", ue = "_chooseBetweenOffices_1uiec_21", fe = "_singleTab_1uiec_25", v = {
  officeTabs: ce,
  chooseBetweenOffices: ue,
  singleTab: fe
}, ge = (e) => ["no", "nn", "en"].includes(e) ? e : "no", be = ({ receptions: e, language: s, officeType: t }) => {
  const n = ge(s), a = b("office", n), o = (r) => {
    var f;
    return r && (r.stedsbeskrivelse || ((f = r.besoeksadresse) == null ? void 0 : f.poststed)) || "(Ukjent sted)";
  }, i = (r) => r.replace(/\s/g, "-").toLowerCase(), m = o(e[0]), [g, _] = I(i(m));
  return !e || e.length === 0 ? null : e.length === 1 ? /* @__PURE__ */ l("div", { className: v.singleTab, children: /* @__PURE__ */ l(j, { ...e[0], language: n, officeType: t }) }) : /* @__PURE__ */ c(k, { children: [
    /* @__PURE__ */ l(B, { className: v.chooseBetweenOffices, children: a("chooseBetweenOffices") }),
    /* @__PURE__ */ c(y, { value: g, onChange: _, className: v.officeTabs, children: [
      /* @__PURE__ */ l(y.List, { children: e.map((r, f) => {
        const p = o(r);
        return /* @__PURE__ */ l(y.Tab, { value: i(p), label: p }, f);
      }) }),
      e.map((r, f) => {
        const p = o(r);
        return /* @__PURE__ */ l(y.Panel, { value: i(p), className: v.singleTab, children: /* @__PURE__ */ l(j, { ...r, language: n, officeType: t }) }, f);
      })
    ] })
  ] });
};
export {
  be as Reception
};
